import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatPercent } from '../utils'

export const mwmRetentionDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'mwmOnboardingcompletedAvg',
      field: 'mwm_nbu_onboarding_completed',
      headerName: 'OnBoarding Completed %',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'retentiond1Avg',
      field: 'retention_d1',
      headerName: 'D1',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'retentiond3Avg',
      field: 'retention_d3',
      headerName: 'D3',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'retentiond7Avg',
      field: 'retention_d7',
      headerName: 'D7',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'retentiond30Avg',
      field: 'retention_d30',
      headerName: 'D30',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'greyFill',
  headerName: 'MWM Retention',
}
